import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';
import { BridgeLandingPage } from '../../../bridge/landingPage/BridgeLandingPage';
import { BridgeEstimates } from '../../../bridge/estimates/BridgeEstimates';
import { BridgeApplications } from '../../../bridge/applications/BridgeApplications';
import { BridgeOutstanding } from '../../../bridge/outstanding/BridgeOutstanding';
import { BridgePerformance } from '../../../bridge/performance/BridgePerformance';
import { BridgeRepaid } from '../../../bridge/repaid/BridgeRepaid';

export default function BridgeRoutes() {
    return (
        <>
            <Route
                path='/bridge'
                element={
                    <RequireAdmin>
                        <BridgeLandingPage />
                    </RequireAdmin>
                }
            />
            <Route
                path='/bridge/estimates'
                element={
                    <RequireAdmin>
                        <BridgeEstimates />
                    </RequireAdmin>
                }
            />
            <Route
                path='/bridge/applications'
                element={
                    <RequireAdmin>
                        <BridgeApplications />
                    </RequireAdmin>
                }
            />
            <Route
                path='/bridge/outstanding'
                element={
                    <RequireAdmin>
                        <BridgeOutstanding />
                    </RequireAdmin>
                }
            />
            <Route
                path='/bridge/performance'
                element={
                    <RequireAdmin>
                        <BridgePerformance />
                    </RequireAdmin>
                }
            />
            <Route
                path='/bridge/repaid'
                element={
                    <RequireAdmin>
                        <BridgeRepaid />
                    </RequireAdmin>
                }
            />
        </>
    );
}
